import { render, staticRenderFns } from "./CreateSegment.vue?vue&type=template&id=8fbf0a5c&"
import script from "./CreateSegment.vue?vue&type=script&lang=js&"
export * from "./CreateSegment.vue?vue&type=script&lang=js&"
import style0 from "./CreateSegment.vue?vue&type=style&index=0&id=8fbf0a5c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports